import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import classNames from 'classnames';
import TabContent from '../TabContent/TabContent';
import TabTitle from '../TabTitle/TabTitle';
var css = {
  "tabsNav": "rui-WlHVT"
};
var TabsContainer = /*#__PURE__*/function (_React$Component) {
  function TabsContainer(props) {
    var _this;
    _classCallCheck(this, TabsContainer);
    _this = _callSuper(this, TabsContainer, [props]);
    var tabs = (props.children || []).filter(function (child) {
      return child.type === TabTitle;
    });
    var contents = (props.children || []).filter(function (child) {
      return child.type === TabContent;
    });
    var selected = tabs.reduce(function (memo, tab, key) {
      return tab.props.selected ? key : memo;
    }, 0);
    _this.state = {
      tabs: tabs,
      contents: contents,
      selected: selected
    };
    _this.bindings = {
      onClickTab: function onClickTab(tab) {
        return _this.onClickTab.bind(_this, tab);
      }
    };
    return _this;
  }
  _inherits(TabsContainer, _React$Component);
  return _createClass(TabsContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateContent();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.children !== this.props.children) {
        this.updateContent();
      }
    }
  }, {
    key: "updateContent",
    value: function updateContent() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var tabs = (props.children || []).filter(function (child) {
        return child.type === TabTitle;
      });
      var contents = (props.children || []).filter(function (child) {
        return child.type === TabContent;
      });
      var selected = tabs.reduce(function (memo, tab, key) {
        return tab.props.selected ? key : memo;
      }, 0);
      if (props.controlled) {
        this.setState({
          tabs: tabs,
          contents: contents,
          selected: selected
        });
      } else {
        this.setState({
          tabs: tabs,
          contents: contents
        });
      }
    }
  }, {
    key: "onClickTab",
    value: function onClickTab(tab, _, event) {
      this.props.onClick(tab.id, event);
      this.setState({
        selected: tab.id
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var tabsWithProps = React.Children.map(this.state.tabs, function (child, key) {
        return /*#__PURE__*/React.cloneElement(child, {
          id: key,
          onClick: _this2.bindings.onClickTab({
            id: key
          }),
          selected: key === _this2.state.selected,
          selectedStyle: _this2.props.selectedStyle
        });
      });
      var contentsWithProps = React.Children.map(this.state.contents, function (child, key) {
        return /*#__PURE__*/React.cloneElement(child, {
          selected: key === _this2.state.selected
        });
      });
      var dataAutId = this.props['data-aut-id'];
      return /*#__PURE__*/React.createElement("div", {
        className: this.props.className,
        "data-aut-id": dataAutId,
        style: this.props.style
      }, /*#__PURE__*/React.createElement("ul", {
        className: classNames(css.tabsNav, this.props.listClassName),
        style: this.props.listStyle,
        ref: this.props.innerRef,
        key: "tabs-container"
      }, tabsWithProps), (contentsWithProps || []).filter(function (content) {
        return content.props.selected;
      }));
    }
  }]);
}(React.Component);
TabsContainer.defaultProps = {
  style: {},
  onClick: function onClick() {},
  className: '',
  listClassName: '',
  selectedStyle: {},
  listStyle: {},
  controlled: false,
  'data-aut-id': 'tabsContainer',
  innerRef: null
};
export default TabsContainer;